<sync-dialog
  [config]="{
    title: file.name,
    isClosable: true,
  }"
  [onClose]="close"
  [open]="open"
  [isFullScreen]="true"
>
  <app-file-info
    [histId]="histId"
    [selectedRows]="selectedRows">
  </app-file-info>
</sync-dialog>
